import "./ShoeTechSizeGuide.module.css";
import Header from "@/reusable_sections/Header";
import AnatomyOfAStride from "./sections/AnatomyOfAStride";
import UniversalSizeMatrix from "./sections/UniversalSizeMatrix";
import ExpertConsultation from "./sections/ExpertConsultation";
import TheStrideFooter from "@/reusable_sections/Footer";
export default function ShoeTechSizeGuidePage() {
  return <div>
      <Header />
      <AnatomyOfAStride />
      <UniversalSizeMatrix />
      <ExpertConsultation />
      <TheStrideFooter />
    </div>;
}